(function($){
    $(function(){
        /***Sticky Header */
        var header = $("#main-nav");
        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();
            if (scroll >= 40 && $(this).width() > 769) {
                header.addClass("fixed-top");
            } else {
                header.removeClass('fixed-top');
            }
        });

        /*** MOBILE NAV */
        var $topNav = $('#top-menu');
        //var $langNav = $('.sf-lang-selector', '.top-nav-wrapper');
        //var $socialLinks = $('#social-menu a');
        var $siteSearch = $('#searchform').clone();
        var $mainNav = $('#main-menu');
        var $logo = $('.navbar-brand');

        var $mobileNav = $('.navbar-nav', '#mobile-nav');
        var $mobileWrapper = $('#mobile-nav-wrapper');
        $mobileWrapper.find('.navbar-brand-mobile').append($logo.html());

        $mobileNav.append($mainNav.html());
        $mobileNav.append($topNav.html());

        //$siteSearch.find('input[type=submit]').prop('value', '\\f002');
        $mobileNav.append($('<li>').append($siteSearch.prop('id', 'searchform-mobile')));


        $mobileNav.find('.menu-item, .dropdown-toggle').each(function(){
            $(this).prop('id', $(this).prop('id')+'-mobile');
        });
        $mobileNav.find('.dropdown-menu').each(function(){
            $(this).attr('aria-labelledby', $(this).attr('aria-labelledby')+'-mobile');
        });


        // var $newLangNav = $langNav.find('li').clone();
        // $newLangNav.find('a').addClass('nav-link');
        // $mobileNav.append($('<li class="nav-item">').append($newLangNav.html()));
        // var $social = $('<li class="nav-item social">');
        // $socialLinks.each(function(){
        //     $social.append($(this));
        // });
        // $mobileNav.append($social);

        $mobileNav.find('.nav-item.dropdown').append('<span class="toggle">');

        $('.navbar-toggler').on('click', function () {
            $('.navbar-toggler').toggleClass('clicked');
            //$('#mobile-nav').toggleClass('show');
            $('.overlay').toggleClass('show');
        });

        $('.overlay').on('click', function(){
            $('.navbar-toggler').trigger('click');
        });

        $('.navbar-toggler-icon').on('click', function() {
            $('.mtsnb-hide').trigger('click');
        });

        // $('#mobile-nav .dropdown > a').on('click', function (e) {

        //     var $navItem = $(this).parent('.nav-item');
        //     if ($navItem.hasClass('active')) {
        //         return true;
        //     }
        //     $navItem.addClass('active');
        //     return false;

        // });

        // $('#mobile-nav .dropdown .toggle').on('click', function (e) {

        //     var $navItem = $(this).parent('.nav-item');
        //     $navItem.toggleClass('active');
        //     return false;
        // });


        /*** CARDS */
        $('.card', '.post-grid').on('click', function(e) {
            e.preventDefault();
            var href = $(this).find('a','h4')[0];
            if (href) {
                window.location.href = $(href).attr('href');
            }
        });


        //*** Side Navigation */
        $('.page_item a', '.bsn-list').each(function() {
            $(this).css('padding-left', (1 + $(this).parents('.children').length) + 'rem');
        });

        /*** Home background symbols */
    });
})(jQuery);